import { render } from "./CollectionSummary.vue?vue&type=template&id=2b23f628&scoped=true&ts=true"
import script from "./CollectionSummary.vue?vue&type=script&lang=ts"
export * from "./CollectionSummary.vue?vue&type=script&lang=ts"

import "./CollectionSummary.vue?vue&type=style&index=0&id=2b23f628&lang=scss&scoped=true"

import exportComponent from "/codebuild/output/src866133389/src/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2b23f628"]])

export default __exports__